export const OPEN_SOCIAL_CAMPAIGN_EVENT = 'ss:open-social-campaign';

export function openSocialCampaignInCreativeStudio({ campaign, siteId }) {
  if (typeof window === 'undefined' || !campaign) return;
  window.dispatchEvent(new CustomEvent(OPEN_SOCIAL_CAMPAIGN_EVENT, {
    detail: { campaign, siteId: Number(siteId || campaign.siteId || 0) || null },
  }));
}

